
//State
export type User = Readonly<{
  id: number,
  email: string,
  created_at: Date,
  updated_at?: Date,
  mobile?: string,
  first_name: string,
  last_name?: string,
  user_id: number,
  tenant_id: number,
  disabled: boolean,
  roles: string[],
  quarter_enabled?: boolean,
  clio_enabled?: boolean,
  modules?: string[]
}>

export type LoginResponse = Readonly<{
  user: User,
  token: string
}>

export type AuthState = Readonly<{
  loggedIn: boolean,
  user?: User,
  loggingIn: boolean,
  error?: any
}>

export enum ActionType {
  LOGOUT = '@auth/Logout',
  LOGIN = '@auth/login'
}
